<template>
  <v-card class="pa-0 mx-auto" flat>
    <v-card
      id="uploader"
      ref="uploader"
      class="mx-auto d-flex justify-center align-center rounded-xl flex-column overflow-hidden drag-zone"
      height="200"
      outlined
      @click="openFileInput"
      @dragleave="dragEvent"
      @dragover="dragEvent"
      @drop="dragEvent"
    >
      <v-icon size="68" style="opacity: 0.4">mdi-cloud-upload-outline</v-icon>
      <v-card-title class="justify-center"
        >{{ multiple ? "آپلود عکس‌ها از سیستم" : "آپلود عکس‌ از سیستم" }}
      </v-card-title>
      <v-card-text class="text-center pt-0 text-break">
        {{
          multiple
            ? "فایل‌های عکس را اینجا رها کنید یا"
            : "فایل‌ عکس را اینجا رها کنید یا"
        }}

        <v-btn class="mx-1" color="primary" min-width="75" small>
          کلیک کنید
        </v-btn>
        تا انتخاب شوند.
      </v-card-text>
    </v-card>

    <input
      type="file"
      ref="fileInput"
      :multiple="multiple"
      accept="image/*"
      class="d-none"
      @change="handleFileInputChange"
    />

    <v-card
      v-show="filesPreview.length > 0"
      class="mt-3 mx-auto pa-1 rounded-lg"
      flat
      outlined
    >
      <div v-for="(item, i) in filesPreview" :key="i" class="pa-1 text-center">
        <v-list-item>
          <v-list-item-avatar class="white--text" size="32" rounded>
            <v-img :src="item.url"></v-img>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title v-text="item.name" class="text-right" />
          </v-list-item-content>

          <v-list-item-action>
            <v-btn icon color="error" @click.stop="removeFile(i)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-divider v-if="i < filesPreview.length - 1"></v-divider>
      </div>
    </v-card>
  </v-card>
</template>

<script>
export default {
  name: "LocalImageUploader",
  props: {
    multiple: { type: Boolean, default: true },
  },
  data: () => ({
    filesPreview: [],
  }),
  methods: {
    dragEvent(e) {
      e.stopPropagation();
      e.preventDefault();
      let uploader = this.$refs.uploader;

      if (
        e.type === "dragover" &&
        !uploader.$el.classList.contains("drag-over")
      ) {
        uploader.$el.classList.add("drag-over");
      } else if (
        e.type === "dragleave" &&
        uploader.$el.classList.contains("drag-over")
      ) {
        uploader.$el.classList.remove("drag-over");
      } else if (e.type === "drop") {
        uploader.$el.classList.remove("drag-over");
        const files = e.dataTransfer.files;
        this.processFiles(files);
      }
    },
    openFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileInputChange(e) {
      const files = e.target.files;
      this.processFiles(files);
      e.target.value = null;
    },
    processFiles(files) {
      if (!files || files.length === 0) return;

      Array.from(files).forEach((file) => {
        if (!file.type.startsWith("image/")) return;

        const url = URL.createObjectURL(file);
        this.filesPreview.push({
          name: file.name,
          file: file,
          url: url,
        });
      });

      this.emitUpdate();
    },
    removeFile(index) {
      URL.revokeObjectURL(this.filesPreview[index].url);
      this.filesPreview.splice(index, 1);
      this.emitUpdate();
    },
    emitUpdate() {
      this.$emit("input", this.filesPreview);
    },
  },
  beforeDestroy() {
    this.filesPreview.forEach((item) => URL.revokeObjectURL(item.url));
  },
};
</script>

<style scoped>
.drag-zone {
  cursor: pointer;
  border: 2px dashed #ccc !important;
  transition: all 0.3s ease;
}
.drag-zone:hover,
.drag-over {
  background-color: #f0f8ff !important;
  border-color: #1976d2 !important;
}
</style>
